const TIER_ORDER = {
  free: 0,
  plus: 1,
  premium: 2,
  staff: 3,
};

const FALLBACK_CAPACITY_BY_TIER = {
  free: 15,
  plus: 30,
  premium: 50,
  staff: 100,
};

const normalizeKnownTier = (value) => {
  const tier = String(value || "").trim().toLowerCase();
  return Object.prototype.hasOwnProperty.call(TIER_ORDER, tier) ? tier : null;
};

export const resolveAccountSubscriptionTier = (account) => {
  const explicitTier = normalizeKnownTier(account?.subscription_tier);
  let tier = explicitTier || "free";

  if (account?.has_plus_access && TIER_ORDER[tier] < TIER_ORDER.plus) {
    tier = "plus";
  }
  if (
    account?.has_premium_subscription
    && TIER_ORDER[tier] < TIER_ORDER.premium
  ) {
    tier = "premium";
  }
  if (
    (account?.is_staff || account?.is_superuser)
    && TIER_ORDER[tier] < TIER_ORDER.staff
  ) {
    tier = "staff";
  }

  return tier;
};

export const getEventHostTransferPolicyPreview = (event, candidate) => {
  // The event tier returned by the API is authoritative because a transferred
  // event can be capped below the current host's personal subscription.
  const sourceTier = normalizeKnownTier(event?.event_subscription_tier)
    || resolveAccountSubscriptionTier(event?.host);
  const targetTier = resolveAccountSubscriptionTier(candidate);
  const effectiveTier = TIER_ORDER[targetTier] < TIER_ORDER[sourceTier]
    ? targetTier
    : sourceTier;

  const configuredCapacity = Number(
    event?.host_transfer_capacity_limits?.[effectiveTier]
  );
  const capacityLimit = Number.isFinite(configuredCapacity) && configuredCapacity > 0
    ? configuredCapacity
    : FALLBACK_CAPACITY_BY_TIER[effectiveTier];
  const occupiedPlaces = Math.max(
    0,
    Number(event?.host_transfer_occupied_places || event?.participants_count || 0)
  ) + (candidate?.source === "waitlist" ? 1 : 0);

  return {
    sourceTier,
    targetTier,
    effectiveTier,
    capacityLimit,
    occupiedPlaces,
    isDowngrade: TIER_ORDER[effectiveTier] < TIER_ORDER[sourceTier],
    recipientIsHigherTier: TIER_ORDER[targetTier] > TIER_ORDER[sourceTier],
    disablesPremiumFeatures:
      TIER_ORDER[sourceTier] >= TIER_ORDER.premium
      && TIER_ORDER[effectiveTier] < TIER_ORDER.premium,
    blocked: occupiedPlaces > capacityLimit,
  };
};
